interface ILanguageInfo {
    iso2: string;
    englishLabel: string;
    nativeLabel: string;
}

// Ordered by popularity for North American businesses
const langArr: Iterable<[string, ILanguageInfo]> = [
    ['en', { iso2: 'en', englishLabel: 'English', nativeLabel: 'English' }],
    ['es', { iso2: 'es', englishLabel: 'Spanish', nativeLabel: 'Español' }],
    ['fr', { iso2: 'fr', englishLabel: 'French', nativeLabel: 'français' }],
    ['zh', { iso2: 'zh', englishLabel: 'Chinese', nativeLabel: '汉语/漢語' }],
    ['pt', { iso2: 'pt', englishLabel: 'Portuguese', nativeLabel: 'Português' }],
    ['ar', { iso2: 'ar', englishLabel: 'Arabic', nativeLabel: 'اَلْعَرَبِيَّةُ' }],
    ['ko', { iso2: 'ko', englishLabel: 'Korean', nativeLabel: '한국어/韓國語' }],
    ['hi', { iso2: 'hi', englishLabel: 'Hindi', nativeLabel: 'हिंदी' }],
    ['de', { iso2: 'de', englishLabel: 'German', nativeLabel: 'Deutsch' }],
    ['ja', { iso2: 'ja', englishLabel: 'Japanese', nativeLabel: '日本語' }],
    ['ru', { iso2: 'ru', englishLabel: 'Russian', nativeLabel: 'русский' }],
    ['pa', { iso2: 'pa', englishLabel: 'Punjabi', nativeLabel: 'ਪੰਜਾਬੀ' }],
    ['am', { iso2: 'am', englishLabel: 'Amharic', nativeLabel: 'አማርኛ' }],
    ['mn', { iso2: 'mn', englishLabel: 'Mongolian', nativeLabel: 'монгол хэл / ᠮᠣᠩᠭᠣᠯ ᠬᠡᠯᠡ' }],
];

const langCodeToInfo = new Map<string, ILanguageInfo>(langArr);

function getLangInfos(excludeIso2Codes: Set<string>): ILanguageInfo[] {
    const langCodeToLabelArr = Array.from(langCodeToInfo.entries());
    const results = langCodeToLabelArr
        .filter(([langCode, info]) => !excludeIso2Codes.has(langCode))
        .map(([langCode, info]) => info);
    return results;
}

export {langCodeToInfo, getLangInfos, type ILanguageInfo}
